import type { Types } from '@cornerstonejs/core';

type CornerstoneRuntime = {
  cornerstone: typeof import('@cornerstonejs/core');
};

export function getCornerstoneRuntime(
  extensionManager: AppTypes.ExtensionManager
): CornerstoneRuntime {
  const utilities = extensionManager.getModuleEntry(
    '@ohif/extension-cornerstone.utilityModule.common'
  );

  if (!utilities?.exports?.getCornerstoneLibraries) {
    throw new Error('Cornerstone utilities are not available');
  }

  return utilities.exports.getCornerstoneLibraries() as CornerstoneRuntime;
}

export type CornerstoneViewport = Types.IStackViewport | Types.IVolumeViewport;
